// extracted by mini-css-extract-plugin
module.exports = {"card":"JobCard_card__YYBcd","summary":"JobCard_summary__oSzt0","title":"JobCard_title__g1jPG","meta":"JobCard_meta__rKm_x","deadline":"JobCard_deadline__j0ajq"};